<template>
  <div class="body">
    <h2
      v-if="component.component === 'title'"
      :type="component.type">
      {{ component.content }}
    </h2>
    <ul
      v-if="component.component === 'ul'" class="checklist checklist--green">
      <template v-for="(content, index) in component.content">
        <li>{{ content }}</li>
      </template>
    </ul>
    <p
      v-if="component.component === 'text'"
      :type="component.type">
      <span v-html="component.content"></span>
    </p>
    <template
      v-if="component.component === 'div'"
      :type="component.type">
      <div v-html="component.content"></div>
    </template>
    <input
      v-if="component.component === 'input'
      && component.type === 'text'"
      :type="component.type"
      :name="component.name"
      size="60"
      maxlength="60"
      :required="component.required ? 'required' : false"
      :placeholder="component.placeholder"
      v-model="personal[component.name]">
    <input
      v-if="component.component === 'input'&& component.type === 'email'"
      :type="component.type"
      :name="component.name"
      size="60"
      maxlength="60"
      v-on:keyup="checkEmail"
      :class="isError"
      :placeholder="component.placeholder"
      v-model="personal[component.name]">
    <template
      v-if="component.component === 'input' && component.type === 'checkbox'">
      <input
        :type="component.type"
        :name="component.name"
        :id="component.name"
        v-model="personal[component.name]"
        @change="setChecked(component.name)">
      <label
        :for="component.name">
        <span v-html="component.label"></span>
      </label>
    </template>
    <button
      v-if="component.component === 'input'
      && component.type === 'submit' && personal.email && personal.accept_conditions"
      class="next-step btn btn-color-01"
      id="form-tips-sent"
      type="submit"
      v-on:click="checkForm">
      {{ component.value }}
    </button>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        errorActive: false
      }
    },
    props: {
      component: {
        type: Object,
        required: true
      },
      personal: {
        type: Array,
      }
    },
    computed: {
      isError() {
        return this.errorActive ? 'error' : '';
      }
    },
    methods: {
      checkForm() {
        if (this.validEmail(this.personal.email)) {
          this.$emit('checkform')
          this.subscribeNewsletter()
        } else {
          this.errorActive = true;
        }
      },
      checkEmail() {
        if (!this.validEmail(this.personal.email)) {
          this.errorActive = true;
        } else {
          this.errorActive = false;
        }
      },
      validEmail: function (email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      setChecked(item) {
        if (this.component.name == 'relevante_email') {
          if (this.personal.subscribe == 'relevante_email') {
            this.personal.subscribe = 'no';
          } else {
            this.personal.subscribe = item;
          }
        }
      },
      subscribeNewsletter() {
        if (this.personal.subscribe == 'relevante_email') {
          fetch(`https://mailing.driessengroep.nl/x/plugin/?pName=script_subscribe&MIDRID=S7a1sAAAA06&pLang=nl&Z=-1445642268&email=${this.personal.email}`, { mode: 'no-cors' })
            .then(response => {
              console.log("Subscription request sent");
            })
            .catch(error => {
              console.error("Error sending subscription request: ", error);
            });
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/GenerateHTML.vue